import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Alert, AlertDescription } from '../ui/alert';
import { Download, Upload } from 'lucide-react';

export const BulkImportSessionsDialog = ({
  open, onOpenChange, file, onFileChange, results, loading, onDownloadTemplate, onImport,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg">
      <DialogHeader>
        <DialogTitle>Bulk Import Sessions</DialogTitle>
        <DialogDescription>Import sessions from Excel</DialogDescription>
      </DialogHeader>
      <div className="space-y-4 pt-4">
        <div className="p-3 bg-muted rounded">
          <p className="text-sm mb-2">Step 1: Download template</p>
          <Button variant="outline" size="sm" onClick={onDownloadTemplate}>
            <Download className="w-4 h-4 mr-2" />Download Template
          </Button>
        </div>
        <div className="p-3 border rounded">
          <p className="text-sm mb-2">Step 2: Upload file</p>
          <Input type="file" accept=".xlsx,.xls" onChange={onFileChange} />
        </div>
        {results && (
          <Alert>
            <AlertDescription>
              Imported {results.successful} of {results.total_rows} sessions
            </AlertDescription>
          </Alert>
        )}
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Close</Button>
          <Button onClick={onImport} disabled={!file || loading}>
            <Upload className="w-4 h-4 mr-2" />{loading ? 'Importing...' : 'Import'}
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default BulkImportSessionsDialog;
